import React, { useEffect, useState } from "react";
import {
  getSidebarThemeOptions,
  getSidebarTheme,
  setSidebarTheme,
} from "../utils/sidebarTheme";
import "../assets/css/Settings.css";

/**
 * @param {"office"|"portal"} scope
 * @param {(theme: string) => void} [onChange] called after a new theme is applied
 */
function SidebarThemeSettings({ scope, onChange }) {
  const [theme, setTheme] = useState(() => getSidebarTheme(scope));

  useEffect(() => {
    const onChange = (e) => {
      if (e?.detail?.scope === scope && e.detail.theme) {
        setTheme(e.detail.theme);
      }
    };
    window.addEventListener("sidebarThemeChanged", onChange);
    return () => window.removeEventListener("sidebarThemeChanged", onChange);
  }, [scope]);

  const handleSelect = (id) => {
    if (id === theme) return;
    const next = setSidebarTheme(scope, id);
    setTheme(next);
    if (onChange) onChange(next);
  };

  return (
    <section className="settings-section" aria-labelledby="sidebar-theme-heading">
      <h2 id="sidebar-theme-heading" className="settings-section__title">
        Left navigation background
      </h2>
      <p className="settings-section__hint">
        Choose how the left menu looks. Your choice is saved on this device.
      </p>
      <div className="settings-theme-options" role="radiogroup" aria-label="Left navigation background">
        {getSidebarThemeOptions(scope).map((opt) => {
          const selected = theme === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`settings-theme-option${selected ? " is-selected" : ""}`}
              onClick={() => handleSelect(opt.id)}
            >
              <span
                className={`settings-theme-swatch settings-theme-swatch--${opt.id}`}
                aria-hidden="true"
              />
              <span className="settings-theme-option__label">{opt.label}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default SidebarThemeSettings;
